import React from "react"
import { off_schedule_inventories_path } from "@/routes"

const OffScheduleButton = () => {
  const exportInventoryData = () => {
    window.open(off_schedule_inventories_path(), "_blank").focus()
  }

  return (
    <button className="btn btn-secondary" onClick={exportInventoryData}>
      <span className="fas fa-arrow-right me-2" />
      Off-Schedule Departures
    </button>
  )
}
export default OffScheduleButton
